import { DATA_CHECK_TYPES } from '../constants';
import { useStore } from '../../store';

export const requiredDataChecker = (type: string) => {
  const summaryData = useStore().getSummaryData();

  switch (type) {
    case DATA_CHECK_TYPES.EMERGENCY_BUCKET_DASHBOARD:
      return summaryData?.emergencyBucketResponse?.available;
    default:
      return true;
  }
};
